/**
 * @generated SignedSource<<1e78525f2ece1bb7746f18e3a0ee6262>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type de_BetterDocExchangeOperation = "CANCEL_RECOMMENDATION" | "CREATE_RECOMMENDATION" | "GET_ANAMNESIS_INFO_SCHEMAS" | "GET_RECOMMENDATION" | "LIST_RECOMMENDATIONS" | "SEARCH_CARE_PROVIDERS" | "SELECT_MEDIC" | "SEND_REFERRAL_SLIP" | "SIMULATE_PATIENT_SELECTION" | "SIMULATE_RESEARCH" | "SIMULATE_SECOND_OPINION_VISIT_CONFIRMATION";
export type de_BetterDocExchangeOutcome = "CANCELLED" | "FAILED" | "PENDING" | "RESPONDED" | "TIMED_OUT" | "TOKEN_UNAVAILABLE";
import { FragmentRefs } from "relay-runtime";
export type betterDocExchangesQueryListFragment$data = {
  readonly exchanges: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly createdBy: string;
        readonly durationMilliseconds: number | null;
        readonly exchangeId: number;
        readonly failureKind: string | null;
        readonly hasUnexpectedResponse: boolean;
        readonly httpMethod: string;
        readonly isTestCase: boolean;
        readonly operation: de_BetterDocExchangeOperation;
        readonly outcome: de_BetterDocExchangeOutcome;
        readonly requestUri: any;
        readonly responseStatusCode: number | null;
        readonly startedAt: string;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "betterDocExchangesQueryListFragment";
};
export type betterDocExchangesQueryListFragment$key = {
  readonly " $data"?: betterDocExchangesQueryListFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"betterDocExchangesQueryListFragment">;
};

import BetterDocExchangesPaginationQuery_graphql from './BetterDocExchangesPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "exchanges"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "filter"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*:: as any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*:: as any*/)
      },
      "fragmentPathInResult": [],
      "operation": BetterDocExchangesPaginationQuery_graphql
    }
  },
  "name": "betterDocExchangesQueryListFragment",
  "selections": [
    {
      "alias": "exchanges",
      "args": [
        {
          "kind": "Variable",
          "name": "filter",
          "variableName": "filter"
        }
      ],
      "concreteType": "de_BetterDocExchangeSummaryConnection",
      "kind": "LinkedField",
      "name": "__BetterDocExchangesFragment_exchanges_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "de_BetterDocExchangeSummaryEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "de_BetterDocExchangeSummary",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "exchangeId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "operation",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdBy",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "httpMethod",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "requestUri",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isTestCase",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasUnexpectedResponse",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "responseStatusCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "durationMilliseconds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startedAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "outcome",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "failureKind",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8a809fe3e204f6dad395bc9f29de8d18";

export default node;
